module.exports = {"140829100":"圣人涧镇","140829101":"常乐镇","140829102":"张店镇","140829103":"张村镇","140829104":"曹川镇","140829105":"三门镇","140829106":"部官镇","140829107":"洪池镇","140829201":"杜马乡","140829400":"平陆县社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140829.json
// module id = 430
// module chunks = 0